import { RiArrowDownSLine } from "@remixicon/react";
import React, {
    CSSProperties,
    ReactElement,
    ReactNode,
} from "react";
import { ResizableBox } from "react-resizable";
import Styles from "./Resizable.module.scss";

interface Size {
    width: number;
    height: number
}
export type Direction = "e" | "w" | "n" | "s" | "se" | "sw" | "ne" | "nw";
export interface ResizableProps {
    children: ReactNode;
    axis?: "x" | "y" | "both";
    direction: Direction
    minSize?: number;
    maxSize?: number;

    minWidth?: number;
    maxWidth?: number;

    minHeight?: number;
    maxHeight?: number;

    defaultWidth?: number;
    defaultHeight?: number;

    defaultSize?: number;
    className?: string;
    draggableOpts?: Record<string, unknown>;

    onDoneResize?: (size: Size) => void;

    style?: CSSProperties;
}

interface HandleProps {
    direction: Direction;
}

export const ResizeHandle = React.forwardRef<HTMLDivElement, HandleProps>((props, ref) => (
    <div
        ref={ref}
        {...props}
        className={`${Styles["react-resizable-handle"]} ${Styles[`react-resizable-handle-${props.direction}`]}`}
    >
        {(props.direction === "se" || props.direction === "nw") && <RiArrowDownSLine />}
    </div>
));

const Resizable = React.forwardRef((
    props: ResizableProps,
    ref: React.ForwardedRef<ResizableBox>,
): ReactElement => {
    const min = props.minSize ?? 300;
    const max = props.maxSize ?? 500;
    const defaultSize = props.defaultSize ?? 400;
    props.defaultSize?.toExponential();
    props.direction?.capitalize();

    const isAxisX = props.axis === "x" || props.axis === "both";
    const isAxisY = props.axis === "y" || props.axis === "both";

    return (
        <ResizableBox
            className={`${props.className} ${Styles["react-resizable"]} ${Styles[`react-resizable-${props.axis}`]}`}
            width={isAxisX ? (props.defaultWidth ?? defaultSize) : 0}
            height={isAxisY ? (props.defaultHeight ?? defaultSize) : 0}
            minConstraints={[isAxisX ? (props.minWidth ?? min) : 0, isAxisY ? (props.minHeight ?? min) as number : 0]}
            maxConstraints={[isAxisX ? (props.maxWidth ?? max) : 0, isAxisY ? (props.maxHeight ?? max) as number : 0]}
            resizeHandles={[props.direction]}
            handle={<ResizeHandle direction={props.direction} />}
            draggableOpts={props.draggableOpts}
            axis={props.axis}
            style={props.style}
            onResize={(__, data) => {
                props.onDoneResize?.(data.size);
            }}
            ref={ref}
        >
            {props.children}
        </ResizableBox>
    );
});

Resizable.defaultProps = {
    axis: "x",
    defaultSize: 400,
    minSize: 300,
    maxSize: 500,
    className: "",
    draggableOpts: undefined,

    minWidth: undefined,
    maxWidth: undefined,
    minHeight: undefined,
    maxHeight: undefined,
    defaultWidth: undefined,
    defaultHeight: undefined,
    onDoneResize: undefined,
    style: undefined,
};

export default Resizable;
